import { render } from "./SirenSearchBar.vue?vue&type=template&id=23843d3a&scoped=true"
import script from "./SirenSearchBar.vue?vue&type=script&lang=js"
export * from "./SirenSearchBar.vue?vue&type=script&lang=js"

import "./SirenSearchBar.vue?vue&type=style&index=0&id=23843d3a&lang=scss&scoped=true"
import "./SirenSearchBar.vue?vue&type=style&index=1&id=23843d3a&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23843d3a"]])

export default __exports__